<template>
  <el-dialog
    :model-value="exportStore.visible"
    :title="exportStore.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :before-close="handleBeforeClose"
    width="509px"
    :align-center="true"
    class="export-progress-dialog"
    @closed="handleClosed"
  >
    <!-- 导出中 -->
    <div v-if="exportStore.isExporting" class="progress-body">
      <!-- 环形渐变旋转动画 -->
      <svg
        class="spinner-icon"
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g clip-path="url(#export_spinner_clip)">
          <g transform="matrix(0.03 0 0 -0.03 30 30)">
            <foreignObject x="-1166.67" y="-1166.67" width="2333.33" height="2333.33">
              <div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                  background: conic-gradient(
                    from 90deg,
                    rgba(99, 36, 235, 1) 0deg,
                    rgba(241, 82, 158, 1) 136.8deg,
                    rgba(255, 255, 255, 0) 360deg
                  );
                  height: 100%;
                  width: 100%;
                  opacity: 1;
                "
              ></div>
            </foreignObject>
          </g>
        </g>
        <path
          d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM30 9.975C41.0473 9.975 50.025 18.9569 50.025 30C50.025 41.0432 41.0473 50.025 30 50.025C18.9527 50.025 9.975 41.0432 9.975 30C9.975 18.9569 18.9527 9.975 30 9.975Z"
          data-figma-gradient-fill="true"
        />
        <circle cx="55" cy="30" r="5" fill="#6324EB" />
        <defs>
          <clipPath id="export_spinner_clip">
            <path
              d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM30 9.975C41.0473 9.975 50.025 18.9569 50.025 30C50.025 41.0432 41.0473 50.025 30 50.025C18.9527 50.025 9.975 41.0432 9.975 30C9.975 18.9569 18.9527 9.975 30 9.975Z"
            />
          </clipPath>
        </defs>
      </svg>

      <!-- 进度文案 -->
      <div class="progress-text">
        {{ exportStore.displayMessage || `正在${exportStore.title}中....${exportStore.percentage}%` }}
      </div>

      <!-- 副标题 -->
      <div class="progress-subtitle">请稍等片刻，勿刷新或关闭网页</div>
    </div>

    <!-- 导出完成 -->
    <div v-else-if="exportStore.isComplete" class="complete-body">
      <!-- 成功图标 -->
      <div class="success-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="28" fill="#55aa68" />
          <path
            d="M18 32.5L27.5 42L46 22"
            stroke="white"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <!-- 成功文案 -->
      <div class="complete-text">导出成功！点击下载按钮选择保存的位置</div>

      <!-- 操作按钮 -->
      <div class="complete-actions">
        <button class="btn-download" @click="handleDownload">
          下载文件
        </button>
        <div class="btn-print-wrapper">
          <button class="btn-print" disabled>印刷实体画册</button>
          <span class="coming-soon-badge">即将上线</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { useExportStore } from '@/store';

const exportStore = useExportStore();

function handleBeforeClose(done: () => void) {
  done();
}

function handleClosed() {
  exportStore.close();
}

function handleDownload() {
  exportStore.download();
}
</script>

<style scoped>
/* ===== el-dialog 面板样式 ===== */
.export-progress-dialog :deep(.el-dialog) {
  width: 509px;
  background: linear-gradient(180deg, #f6f9f7 0%, #f6f9f7 100%);
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
}

/* Header */
.export-progress-dialog :deep(.el-dialog__header) {
  padding: 32px 32px 0 32px;
  margin: 0;
}

.export-progress-dialog :deep(.el-dialog__title) {
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #333940;
}

.export-progress-dialog :deep(.el-dialog__headerbtn) {
  top: 32px;
  right: 32px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.export-progress-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
  color: #999999;
  font-size: 12px;
}

.export-progress-dialog :deep(.el-dialog__headerbtn:hover) {
  background: rgba(0, 0, 0, 0.06);
}

/* Body */
.export-progress-dialog :deep(.el-dialog__body) {
  padding: 0 32px !important;
}

.export-progress-dialog :deep(.el-dialog__footer) {
  display: none;
}

/* ===== 导出中状态 ===== */
.progress-body {
  height: 308px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 环形渐变旋转动画 */
.spinner-icon {
  display: block;
  width: 60px;
  height: 60px;
  margin-bottom: 26px;
  flex: 0 0 auto;
  animation: spinner-spin 0.9s linear infinite;
}

@keyframes spinner-spin {
  to {
    transform: rotate(360deg);
  }
}

/* 进度文字 */
.progress-text {
  margin-bottom: 10px;
  font-family: 'Source Han Sans CN VF', Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #160211;
  text-align: center;
}

/* 副标题 */
.progress-subtitle {
  font-family: 'Source Han Sans CN VF', Inter, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #6e6a7c;
  text-align: center;
}

/* ===== 导出完成状态 ===== */
.complete-body {
  height: 308px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.success-icon {
  margin-bottom: 20px;
}

.complete-text {
  margin-bottom: 24px;
  font-family: 'Source Han Sans CN VF', Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #160211;
  text-align: center;
}

/* 操作按钮区域 */
.complete-actions {
  display: flex;
  align-items: center;
  gap: 18px;
}

.btn-download {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 6px;
  background: #6033e1;
  cursor: pointer;
  font-family: Laila, Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  white-space: nowrap;
}

.btn-download:hover {
  background: #7c5cec;
}

.btn-print-wrapper {
  position: relative;
}

.btn-print {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #c2c2c2;
  border-radius: 6px;
  background: #ffffff;
  cursor: not-allowed;
  font-family: Laila, Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  line-height: 22px;
  white-space: nowrap;
  opacity: 0.6;
}

.coming-soon-badge {
  position: absolute;
  top: -10px;
  right: -8px;
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 6px 0 4px;
  font-family: 'Source Han Sans CN VF', Inter, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  color: #ffffff;
  background: linear-gradient(90deg, #884cef 0%, #c14cef 100%);
  border-radius: 6px 12px 12px 0;
  white-space: nowrap;
}
</style>
